<template>
  <component :is="comp" v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </component>
</template>

<script>
export default {
  props: {
    defaultComp: {
      type: Function,
      require: true
    },
    lalamoveComp: {
      type: Function
    }
  },
  computed: {
    comp() {
      switch (this.$uiTheme) {
        case 'lalamove':
          return this.lalamoveComp;
        default:
          return this.defaultComp;
      }
    }
  }
};
</script>
